export type Track = {
	title: string;
	src: string;
};

export const TRACKS: Track[] = [
	{ title: '01. Namakara Gatha', src: '/sounds/paritta/01-namakara-gatha.mp4' },
	{ title: '02. Puja Gatha', src: '/sounds/paritta/02-puja-gatha.mp4' },
	{ title: '03. Pubbabhaganamakara', src: '/sounds/paritta/03-pubbabhaganamakara.mp4' },
	{ title: '04. Saranagamana Patha', src: '/sounds/paritta/04-saranagamana-patha.mp4' },
	{ title: '05. Pancasila', src: '/sounds/paritta/05-pancasila.mp4' },
	{ title: '06. Buddhanussati', src: '/sounds/paritta/06-buddhanussati.mp4' },
	{ title: '07. Dhammanussati', src: '/sounds/paritta/07-dhammanussati.mp4' },
	{ title: '08. Sanghanussati', src: '/sounds/paritta/08-sanghanussati.mp4' },
	{ title: '09. Saccakiriya Gatha', src: '/sounds/paritta/09-saccakiriya-gatha.mp4' },
	{ title: '10. Mangala Sutta', src: '/sounds/paritta/10-mangala-sutta.mp4' },
	{ title: '11. Karaniya Metta Sutta', src: '/sounds/paritta/11-karaniya-metta-sutta.mp4' },
	{ title: '12. Brahmavihara Pharanaa', src: '/sounds/paritta/12-brahmavihara-pharana.mp4' },
	{ title: '13. Abhinhapaccavekkahana', src: '/sounds/paritta/13-abhinhapaccavekkahana.mp4' },
	{
		title: '14. Aradhana Tisarana Pancasila',
		src: '/sounds/paritta/14-aradhana-tisarana-pancasila.mp4',
	},
	{ title: '15. Aradhana Dhammadesana', src: '/sounds/paritta/15-aradhana-dhammadesana.mp4' },
	{ title: '16. Ettavatta', src: '/sounds/paritta/16-ettavatta.mp4' },
];
